import React, { Component } from 'react';
import { FaCheck, FaTimes } from 'react-icons/fa';


class Training extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editEntry: false,
            filterBy: {}, sortBy: 'name', sortOrder: 1,
            loading: false,
            data: []
        };
    }
    cancel = () => {
        this.setState({ editEntry: false, loading: false, error: '' })
    }

    editEntry = (entry) => e => {
        this.setState({ editEntry: true, entry: entry, loading: false, error: '' })
    }
    add = () => {
        this.setState({
            editEntry: true, entry:
            {
                "id": generateUniqueId(),
                "name": "",
                "department": "",
                "type": this.state.type,
                "number": "",
                "prompt": "",
                "announceNumber": false,
                "active": true,
                "sayAs": "",
                "alias": [
                ],
                "lastUpdatedUser": ""
            }
            , loading: false, error: ''
        })
    }
    handleChange = (event) => {
        const { name, type, value, checked } = event.target;
        const newValue = type === "checkbox" ? checked : value;

        let error = '';

        if (name === "number" && isNaN(Number(newValue))) {
            error = 'Not a valid Number.';
        }

        if (name === "name") {
            const entryExists = this.props.data.Training.entries.some(entry => entry.name === newValue && entry.id !== this.state.entry.id);
            if (entryExists) {
                error = 'This name already exists in the Training.';
            }
        }

        this.setState({
            entry: {
                ...this.state.entry,
                [name]: newValue
            },
            error: error
        });
    };
    handleChangeIntent(recordId, event) {
        const newIntentId = event.target.value;

        console.log(newIntentId);
        console.log(recordId);

        const updatedData = this.state.data.map(record => {
            if (record.id === recordId) {
                record.intent = newIntentId;
            }
            return record;
        });
        console.log(updatedData);


        this.setState({ data: updatedData });
    }
    confirmTrain = (recordID) => {
        //get the entry from the state array
        this.state.data.find((entry) => {
            if (entry.id === recordID) {
                //send the entry to the server
                this.props.ws.send(JSON.stringify({ route: 'editTrain', entry: entry }))
            }
        })
        //this.setState({ editEntry: false, loading: true, error: '', entry: {} })
    }
    refreshList = () => {
        this.props.ws.send(JSON.stringify({ route: 'getTraining' }))
    }
    deleteTrain = (recordID) => {
        this.state.data.find((entry) => {
            if (entry.id === recordID) {
                //send the entry to the server
                this.props.ws.send(JSON.stringify({ route: 'deleteTrain', entry: entry }))
            }
        })
        //this.setState({ editEntry: false, loading: true, error: '', entry: {} })
    }



    sort = (sortBy) => (e) => {
        var sortOrder
        if (this.state.sortOrder === -1) {
            sortOrder = 1;
        } else {
            sortOrder = -1;
        }
        this.setState({ sortBy: sortBy, sortOrder: sortOrder })
    }

    filter = (field) => (e) => {
        var filterBy = this.state.filterBy
        if (e.target.value.length > 0) {
            filterBy[field] = e.target.value
        } else {
            delete filterBy[field]
        }
        this.setState({ filterBy: filterBy })
    }
    checkType = (e) => {
        console.log(e.target.value)
        this.setState({ type: e.target.value })
    }

    sortFunc(sortBy, sortOrder) {
        return function (a, b) {

            if (sortBy in a && sortBy in b) {
                if (a[sortBy] === b[sortBy]) {
                    return a.name > b.name ? 1 * sortOrder : -1 * sortOrder
                }
                return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
            }
        }
    }

    filterFunc(array, filterBy) {
        return array.filter(function (object) {
            for (var prop in filterBy) {
                if (typeof object[prop] === "undefined") {
                    return false
                }
                if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
                    return false
                }
            }
            return true
        })
    }

    filterIcon(item) {
        return (this.state.sortBy === item ? (this.state.sortOrder == 1) ? " \u25B2" : " \u25BC" : "")
    }


    render() {
        if (this.props.active) {

            //if there is no state.data 
            //Get training data from server
            //if (this.props.data.Training.data.length === 0) {
            //    this.props.ws.send(JSON.stringify({ route: 'getTraining' }))
            //}

            this.state.data = this.props.data.Training.data

            var data = JSON.parse(JSON.stringify(this.state.data));

            //Filtering List
            if (Object.keys(this.state.filterBy).length > 0) {
                data = this.filterFunc(data, this.state.filterBy)
            }

            var intents = [];
            for (var entry of this.props.data.Directory.entries) {
                var name = entry.name;
                if (name.length > 25) {
                    name = name.slice(0, 25) + '...';
                }
                intents.push({ name: name, id: entry.id });
            }
            //sort intents alphabetically
            intents.sort((a, b) => {
                if (a.name > b.name) {
                    return 1;
                }
                else if (a.name < b.name) {
                    return -1;
                }
                else {
                    return 0;
                }
            });


            //Sorting List
            if (this.state.sortBy !== '') {
                data.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
            }
            data = data.filter((entry) => {
                return entry.type === this.state.type
            })
            var editEntry = ""

            var trainingList = []
            var tableHeaders = "";
            tableHeaders = (
                <tr className="dataRow">
                    <th style={{ minWidth: '250px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("response")}>Response {this.filterIcon("response")}</th>
                    <th style={{ minWidth: '300px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("intent")}>Intent {this.filterIcon("intent")}</th>
                    <th style={{ minWidth: '200px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("dateTime")}>Date Time {this.filterIcon("dateTime")}</th>
                    <th style={{ minWidth: '200px', textAlign: 'center' }}>Actions</th>
                </tr>
            );


            for (var record of data) {
                const tempIntents = JSON.parse(JSON.stringify(intents));
                const recordID = JSON.parse(JSON.stringify(record.id));
                const dateTime = new Date(record.dateTime).toLocaleString();
                const intent = tempIntents.find(intent => intent.id === record.intent);
                const intentName = intent ? intent.name : '';
                tempIntents.unshift({ name: intentName, id: record.intent });
                //console.log(record.id);
                trainingList.push(
                    <tr className="dataRow" key={record.id} >
                        <td style={{ minWidth: '250px', textAlign: 'left' }}>{record.response}</td>
                        <td style={{ minWidth: '300px', textAlign: 'left' }}>
                            <select style={{ width: '100%' }} value={record.intent} onChange={(event) => this.handleChangeIntent(recordID, event)}>
                                {tempIntents.map(intent => (
                                    <option key={intent.id} value={intent.id}>{intent.name || 'No Match Found'}</option>
                                ))}
                            </select>
                        </td>


                        <td style={{ minWidth: '200px', textAlign: 'left' }}>{dateTime}</td>
                        <td style={{ minWidth: '200px', textAlign: 'center' }}>
                            <button style={{ backgroundColor: '#008000', color: '#fff', border: 'none', padding: '4px 8px', borderRadius: '4px', cursor: 'pointer', marginRight: '8px' }} onClick={() => this.confirmTrain(recordID)}><FaCheck /></button>
                            <button style={{ backgroundColor: '#f44336', color: '#fff', border: 'none', padding: '4px 8px', borderRadius: '4px', cursor: 'pointer' }} onClick={() => this.deleteTrain(recordID)}><FaTimes /></button>
                        </td>
                    </tr>
                );
            }


            if (trainingList.length === 0) {
                return (
                    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
                            <div className="button confirm" onClick={this.refreshList} title="Refresh List" style={{ borderRadius: '5px', border: 'none', padding: '10px', cursor: 'pointer' }}>
                                Refresh
                            </div>
                        </div>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '50px' }}>
                            <h2 style={{ color: '#2A6AA9', fontWeight: 'bold', fontFamily: 'Arial, Helvetica, sans-serif' }}>All training complete!</h2>
                        </div>
                    </div>
                )
            } else {
                return (
                    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px' }}>
                            <div className="button confirm" onClick={this.refreshList} title="Refresh List" style={{ borderRadius: '5px', border: 'none', padding: '10px', cursor: 'pointer' }}>
                                Refresh
                            </div>
                        </div>
                        <div style={{ flex: '1 0 auto' }}>
                            <table style={{ width: '100%', tableLayout: 'fixed' }}>
                                <thead>
                                    {tableHeaders}
                                </thead>
                                <tbody>
                                    {trainingList}
                                </tbody>
                            </table>
                        </div>
                        {editEntry}
                    </div>

                );
            }




        } else {
            return (
                <div width="100%">

                </div>
            );
        }
    }
}

const icon = "menuWorkflow"
const roles = ["View"]
export { Training, icon, roles }




function generateUniqueId() {
    const timestamp = Date.now().toString(36);
    const randomStr = Math.random().toString(36).slice(2);
    const uniqueId = timestamp + randomStr;
    return uniqueId;
}